import { type QuotePackage, type PricingPlan } from "./helpers";
import { formatCurrency } from "helpers/currency";
import CollapsibleSection from "components/CollapsibleSection";
import PriceBreakdownContent from "./PriceBreakdownContent";
import WhatsIncludedContent from "./WhatsIncludedContent";
import CallButton from "components/CallButton";

/**
 * Other Package Card (oat background, no yellow border)
 */
export default function OtherPackageCard({
  pkg,
  plan,
}: {
  pkg: QuotePackage;
  plan?: PricingPlan;
}) {
  const displayName = pkg.external_plan_name || pkg.plan_name;
  const subtitle = plan?.external?.subtitle;
  const tagline = plan?.external?.tagline;

  return (
    <div className="rounded-md border-[3px] border-oat bg-oat p-6">
      <div className="space-y-4">
        {/* Name and Price - horizontal */}
        <div className="flex items-center justify-between gap-2">
          <span className="font-serif text-3xl italic text-evergreen">
            {displayName}
          </span>
          <span className="text-3xl font-bold text-evergreen">
            {formatCurrency(pkg.total)}
          </span>
        </div>

        {/* Description */}
        {(subtitle || tagline) && (
          <p className="text-sm text-evergreen">
            {subtitle && <span className="font-bold">{subtitle}</span>}
            {tagline && ` ${tagline}`}
          </p>
        )}

        {/* Collapsible sections */}
        <div className="space-y-2">
          <CollapsibleSection title={`What's included in ${displayName}?`}>
            <WhatsIncludedContent
              highlights={plan?.external?.inclusion_highlights}
            />
          </CollapsibleSection>

          <CollapsibleSection title="View price breakdown">
            <PriceBreakdownContent pkg={pkg} />
          </CollapsibleSection>
        </div>

        {/* Call Button */}
        <div className="pt-2">
          <CallButton variant="outline" />
        </div>
      </div>
    </div>
  );
}
